import React from "react";
import { ReactComponent as USFlagSvg } from "assets/images/us-flag.svg";
import { ReactComponent as CAFlagSvg } from "assets/images/ca-flag.svg";
import { ReactComponent as UKFlagSvg } from "assets/images/uk-flag.svg";

interface FlagProps {
  width?: number;
  height?: number;
  className?: string;
}

export const USFlag: React.FC<FlagProps> = ({
  width = 20,
  height = 15,
  className,
}) => {
  return <USFlagSvg width={width} height={height} className={className} />;
};

export const CAFlag: React.FC<FlagProps> = ({
  width = 20,
  height = 15,
  className,
}) => {
  return <CAFlagSvg width={width} height={height} className={className} />;
};

export const UKFlag: React.FC<FlagProps> = ({
  width = 20,
  height = 15,
  className,
}) => {
  return <UKFlagSvg width={width} height={height} className={className} />;
};

export const getCountryFlagComponent = (
  countryCode: string | null | undefined,
  props?: FlagProps
): React.ReactElement | null => {
  if (!countryCode) {
    return null;
  }

  const defaultProps = { width: 25, height: 20, ...props };

  if (countryCode === "US") {
    return <USFlag {...defaultProps} />;
  } else if (countryCode === "CA") {
    return <CAFlag {...defaultProps} />;
  } else if (countryCode === "UK") {
    return <UKFlag {...defaultProps} />;
  }

  return null;
};
